export const DB_MODULE = "db";
export const LOB_MODULE = "lob";

export const PATH_HOME = '/employee-management';
